<template>
<div v-loading="loading">
  <el-table-wrapper class="mr-b25" style="width:100%;" :data="forecastEventTableData" :columns="forecastEventTableColumns" :column-default="columnDefault" header-align="center" :pagination="false" highlight-current-row>
    <template slot-scope="scope" slot="eventlevel-slot">
      <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
    </template>
  </el-table-wrapper>
  <highcharts v-if="!isEmpty(chartData)" class="chart" :options="chartOptions" ref="highchart" />
</div>
</template>

<script>
import { isNil, cloneDeep, isEmpty } from 'lodash';
import moment from 'moment';
import msgUtil from '@/utils/message';
import { heatmapOptions } from '@/constants/chart-options';
import { columnDefault } from '@/constants/table';
import EventCommonApi from '@/api/event/event-common';

/**
 * 이벤트 미래 예측 화면
 */
export default {
  name: 'WEventFuturePredictView',
  props: {
    eventHistData: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      columnDefault,
      forecastEventTableData: null,
      forecastEventTableColumns: [
        {
          prop: 'objName',
          label: '관리대상',
        },
        {
          prop: 'rsctypeName',
          label: '자원 종류',
        },
        {
          prop: 'rscName',
          label: '자원 이름',
        },
        {
          prop: 'rscKeyName',
          label: '자원키 이름',
        },
        {
          prop: 'similarity',
          label: '발행 확률',
          formatter: this.getPercentageFormatter,
        },
      ],
      chartOptions: cloneDeep(heatmapOptions),
      chartData: null,
    };
  },
  watch: {
    eventHistData: {
      handler(value) {
        if (isEmpty(value)) {
          this.reset();
        } else {
          this.loadData();
        }
      },
    },
  },
  methods: {
    isEmpty,
    /**
     * 이벤트 미래 예측 정보를 로드한다.
     * @author Ju
     */
    loadData() {
      const params = {
        hashkeyIdString: this.eventHistData.hashkeyIdString,
        hashkeyId: this.eventHistData.hashkeyIdString,
        startDatetime: moment(this.eventHistData.checkDatetime)
          .subtract(1, 'month')
          .valueOf(),
        endDatetime: this.eventHistData.checkDatetime,
      };
      this.loading = true;
      EventCommonApi.getForecastEvent({
        data: params,
        timeout: 1800000,
      })
        .then((response) => {
          if (response.data.success) {
            if (!isNil(response.data.data)) {
              if (!isNil(response.data.data.events)) {
                this.forecastEventTableData = response.data.data.events;
              }
              if (!isNil(response.data.data.square)) {
                this.chartData = response.data.data.square;
                this.chartOptions.xAxis.categories = response.data.data.square.category;
                this.chartOptions.yAxis.categories = response.data.data.square.category;
                this.chartOptions.series[0].data = response.data.data.square.series;
              }
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '미래 예측 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '미래 예측 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      this.loading = false;
      this.forecastEventTableData = [];
      this.chartOptions = cloneDeep(heatmapOptions);
      this.chartData = null;
    },
    /**
     * 퍼센티지 포맷터
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getPercentageFormatter(row, column, value) {
      let result = value;
      if (value > 0) {
        result = (value * 100).toFixed(2);
      }
      return `${result} %`;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/EventSmartAnalyzerPopup/EventFuturePredictView.vue